<template>
    <div id="contnet">
        <area-quality-course-screen v-bind:isAreaQuality="true" @gradeData="gradeData" @subjectData="subjectData" @versionData="versionData"></area-quality-course-screen>
        <area-quality-course-list @showPlayer="showPlayer"  @isUpload="isUpload" @upLoadData="upLoadData"></area-quality-course-list>
        <video-player v-if="isPlayer" @closePlayer="closePlayer"></video-player>
        <up-load-area-course v-if="isShowUpload" @closeUpload="closeUpload" :datas="datas" :gradeDatas="gradeDatas" :subjectDatas="subjectDatas" :versionDatas="versionDatas"></up-load-area-course>
    </div>

</template>
<script>
import areaQualityCourseScreen from '../MicroClassScreen/areaQualityCourseScreen.vue'
import areaQualityCourseList from '../MicroClassList/areaQualityCourseList.vue'
import VideoPlayer from '../videoPlayer/viderPlayer.vue'
import upLoadAreaCourse from '../upLoad/upLoadAreaCourse.vue'
export default {
    name:'areaQualityCourse',
    data(){
        return{
            isPlayer:false,
            isAreaQuality:true,
            isShowUpload:false,
            datas:null,
            gradeDatas:null,
            subjectDatas:null,
            versionDatas:null
        }
    },
    mounted() {
      this.$nextTick(()=>{
        $(document).scrollTop(0);
      })
    },
    methods:{
        showPlayer(obj){
            this.isPlayer = obj;            //打开播放器  ture
        },
        closePlayer(obj){
            this.isPlayer = obj;            //关闭播放器 false
        },
        isUpload(obj){
            this.isShowUpload = obj;        //打开上传组件
        },
        closeUpload(msg){
            this.isShowUpload = msg;
        },
        upLoadData(msg){
            this.datas = msg;
        },
        gradeData(msg){
          this.gradeDatas = msg;
        },
        subjectData(msg){
          this.subjectDatas = msg;
        },
        versionData(msg){
          this.versionDatas = msg;
        }
    },
    components:{
        areaQualityCourseScreen,areaQualityCourseList,VideoPlayer,upLoadAreaCourse
    }
}
</script>



// WEBPACK FOOTER //
// src/components/areaQualityCourse/areaQualityCourse.vue